const Department = {

    // FIELDS
    "department_name": "Department Name",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "department": "Department",

    // ERROR
    "error_name": "Enter Department Name",
    "error_status": "Select Status",

    // TABLE HEADER
    "table_name": "DEPARTMENT NAME",
    "table_status": "STATUS",

}

export default Department;
